if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.featured = this.dataset.featured;
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (!this.featured) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = document.querySelector('.thb-product-detail .product-images'),
        thumbnails = document.querySelector('.thb-product-detail #Product-Thumbnails');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let hide_variants = productSlider.dataset.hideVariants == 'true',
        flkty = Flickity.data(productSlider),
        images = productSlider.querySelectorAll('.product-images__slide');

      if (flkty && hide_variants) {
        [].forEach.call(images, function (el) {
          el.classList.remove('is-selected');
        });
        if (productSlider.querySelector(mediaId)) {
          productSlider.querySelector(mediaId).classList.add('is-selected');
        }

        productSlider.reInit();
        productSlider.selectCell(mediaId);

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          thumbnails.prepend(activeThumb);
        }
      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);


  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      const product_container = this.closest('.thb-product-detail');
      const thumbnail_container = product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide'
      };

      if (this.hide_variants) {
        this.options.cellSelector = '.product-images__slide, .product-images__slide-item--variant.is-selected';
      }

      // Start Slider
      this.init();
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit() {
      this.flkty.destroy();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        this.prev_button.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        this.prev_button.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        this.next_button.addEventListener('click', (event) => {
          this.flkty.next();
        });
        this.next_button.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          slide = this.flkty.cells[index].element,
          media = slide.querySelector('.product-single__media'),
          active_thumb = this.thumbnails[index];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');
        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: 0,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });
        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });

      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          this.thumbnailClick(thumbnail, index);
        });
      });
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide .product-single__media-image, .product-images__slide-item--variant.is-selected .product-single__media-image'));
      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}
// Black friday href edit
if (document.querySelector('.template-page-black-friday')) {
  document.addEventListener("DOMContentLoaded", function() {
    // Define un objeto que contiene los pares de búsqueda y reemplazo
    var replacements = {
      '/collections/batidoras-black-friday': '#batidoras',
      '/collections/cafeteras-black-friday': '#cafeteras',
      '/collections/freidoras-black-friday': '#freidoras',
      '/collections/hogar-black-friday': '#hogar',
      '/collections/oferta-flash': '#flash'      
    };

    // Obtén todos los elementos <a> en la página actual
    var links = document.querySelectorAll('.template-page-black-friday .collection-card--content a');

    // Recorre todos los elementos <a> en la página actual
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');

      // Verifica si el href coincide con alguno de los valores en replacements
      if (replacements[href]) {
        // Realiza el reemplazo con el valor correspondiente en replacements
        links[i].setAttribute('href', replacements[href]);
      }
    }
  });
}
// Black friday href edit two
if (document.querySelector('.template-page-black-friday')) {
  document.addEventListener("DOMContentLoaded", function() {
    // Define un objeto que contiene los pares de búsqueda y reemplazo
    var replacementsTwo = {
      '/collections/batidoras-black-friday': '/collections/batidoras',
      '/collections/cafeteras-black-friday': '/collections/cafeteras',
      '/collections/freidoras-black-friday': '/collections/freidoras-de-aire',
      '/collections/hogar-black-friday': '/collections/climatizacion'
    };

    // Obtén todos los elementos <a> en la página actual
    var links = document.querySelectorAll('.template-page-black-friday .section-header--button a');

    // Recorre todos los elementos <a> en la página actual
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');

      // Verifica si el href coincide con alguno de los valores en replacementsTwo
      if (replacementsTwo[href]) {
        // Realiza el reemplazo con el valor correspondiente en replacementsTwo
        links[i].setAttribute('href', replacementsTwo[href]);
      }
    }
  });
}

// Promise para dar más o menos altura al bloque en caso de existir o no quantity alert
// Primer bloque de código
function hideOutOfStock() {
    return new Promise(resolve => {
        document.querySelectorAll('div#main-content').forEach(el => {
            const outOfStockElement = el.querySelector('.template-product-85104982-rk7 span.badge.out-of-stock');
            if (outOfStockElement !== null) {
                const inventoryNoticeWrapper = el.querySelector('.template-product-85104982-rk7 .product-inventory-notice--wrapper');
                if (inventoryNoticeWrapper) {
                    inventoryNoticeWrapper.style.display = 'none';
                }
            }
        });
        resolve();
    });
}
// Segundo bloque de código
async function adjustMargin() {
    await hideOutOfStock();

    if (window.matchMedia('(max-width: 768px)').matches) {
        document.querySelectorAll('div#main-content').forEach(el => {
            if (el.querySelector('template-product-85104982-rk7 .product-inventory-notice--wrapper')) {
                el.querySelector('.template-product-85104982-rk7 div#shopify-section-template--19885576585551__16623743398765981b').style.marginTop = '140%';
            } else {
                el.querySelector('.template-product-85104982-rk7 div#shopify-section-template--19885576585551__16623743398765981b').style.marginTop = '120%';
            }
        });
    }
}
// Llamar a la función asincrónica
adjustMargin();

// Ofertas href edit one
/* if (document.querySelector('.template-page-ofertas')) {
  document.addEventListener('DOMContentLoaded', function() {
    // Define un objeto que contiene los pares de búsqueda y reemplazo
    var replacements = {
      '/collections/regalos-ufesa': '#regalos',
      '/collections/freidoras-black-friday': '#freidoras',
      '/collections/calor-textil': '#calor',
      '/collections/climatizacion': '#clima'
    };

    // Obtén todos los elementos <a> en la página actual
    var links = document.querySelectorAll('.template-page-ofertas .collection-card--content a');
   
    // Recorre todos los elementos <a> en la página actual
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');

      // Verifica si el href coincide con alguno de los valores en replacements
     if (replacements[href]) {
        // Realiza el reemplazo con el valor correspondiente en replacements
        links[i].setAttribute('href', replacements[href]);
      }
    }
  });
} */
// Ofertas href edit two
if (document.querySelector('.template-page-ofertas')) {
  document.addEventListener('DOMContentLoaded', function() {
    // Define un objeto que contiene los pares de búsqueda y reemplazo
    var replacementsTwo = {
      '/collections/freidoras-black-friday': '/collections/freidoras-de-aire',
      '/collections/calor-textil-rebajas-verano-2024': '/collections/climatizacion',
      '/collections/freidoras-de-aire-rebajas-verano-2024': '/collections/freidoras-de-aire',
      '/collections/aspiracion-rebajas-verano-2024': '/collections/aspiradoras',
      '/collections/planchas-rebajas-verano-2024': '/collections/cuidado-de-la-ropa',
      '/collections/ventilacion-rebajas-verano-2024': '/collections/ventilacion',
    };

    // Obtén todos los elementos <a> en la página actual
    var links = document.querySelectorAll('.template-page-ofertas .section-header--button a');

    // Recorre todos los elementos <a> en la página actual
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');

      // Verifica si el href coincide con alguno de los valores en replacementsTwo
      if (replacementsTwo[href]) {
        // Realiza el reemplazo con el valor correspondiente en replacementsTwo
        links[i].setAttribute('href', replacementsTwo[href]);
      }
    }
  });
}


if (document.querySelector('.template-page-rebajas') || document.querySelector('.template-page-ofertas-agosto2024') || document.querySelector('.template-page-flash-october24')) {
    document.addEventListener('DOMContentLoaded', function() {
        const boton = document.querySelectorAll('.toggle-box--button');
        boton.forEach(function(postBox) {          
            postBox.addEventListener('click', function() {
                const elementHeight = this.previousElementSibling.querySelectorAll('p')[0].clientHeight;
                if (this.closest('toggle-box').hasAttribute('open')) {
                    this.previousElementSibling.setAttribute('style', 'height:' + (elementHeight + 120) + 'px');
                } else {
                    this.previousElementSibling.setAttribute('style', 'height: 0px');
                }
            });
        });

    }); //DOMContentLoaded
} //template-page-rebajas

if (document.querySelector('.template-product-sensazione')) {
    document.addEventListener('DOMContentLoaded', function() {
        const outOfStockElement = document.querySelectorAll('.product-grid-container span.badge.out-of-stock');
        const noInventorNotice = document.querySelectorAll('.product-grid-container div.product-inventory-notice');
        if (outOfStockElement !== null || noInventorNotice === null) {
          console.log(outOfStockElement.length +' '+ noInventorNotice.length);
            const inventoryNoticeWrapper = document.querySelector('.product-grid-container .product-inventory-notice--wrapper');
            if (inventoryNoticeWrapper) {
                inventoryNoticeWrapper.style.display = 'none';
            }
        }

    }); //DOMContentLoaded
} //template-product-sensazione




/* if (document.querySelector('.template-page-flash-sales')) {
  document.addEventListener('DOMContentLoaded', function() {
    console.log('adadadas');
    const elem = document.querySelectorAll('.template-page-flash-sales .multicolumn__column');
    elem[0].classList.add('active');
    //elem[0].classList.add('active');
    elem[1].classList.add('spent');
    elem[2].classList.add('spent');
    elem[3].classList.add('spent');
    //elem[3].classList.add('standby');

    const activeElement = document.querySelector('.template-page-flash-sales .multicolumn__column.active');
    activeElement.onclick = function () {
      const element = document.getElementById('featured');
      if (element) {
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        });
      }
    }

    const quantity = stockQuantity();
    
    const currentStock = document.querySelector('.template-page-flash-sales .multicolumn__column.active .rte p strong').textContent = quantity;

    document.querySelector('.template-page-flash-sales .product-inventory-notice--text').innerHTML =`<div class="product-inventory-notice--pulse"></div>Sólo quedan <strong>${quantity}</strong> en stock`;

    document.querySelector('.template-page-flash-sales .product-section .product-inventory-notice--bar').setAttribute('style','')
    const inventoryLevel = document.querySelector('.template-page-flash-sales .product-section .product-inventory-notice--bar span');
    inventoryLevel.style.width = quantity + '%';

    
    const boton = document.querySelectorAll('.toggle-box--button');
    boton.forEach(function(postBox) {
        postBox.addEventListener('click', function() {
            const elementHeight = this.previousElementSibling.querySelectorAll('p')[0].clientHeight;
            if (this.closest('toggle-box').hasAttribute('open')) {
                this.previousElementSibling.setAttribute('style', 'height:' + (elementHeight + 120) + 'px');
            } else {
                this.previousElementSibling.setAttribute('style', 'height: 0px');
            }
        });
    });




            const cityArray = ['A Coruña', 'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Baleares', 'Barcelona', 'Burgos', 'Cáceres', 'Cádiz', 'Cantabria', 'Castellón', 'Ciudad Real', 'Córdoba', 'Cuenca', 'Girona', 'Granada', 'Guadalajara', 'Gipuzkoa', 'Huelva', 'Huesca', 'Jaén', 'La Rioja', 'Las Palmas', 'León', 'Lérida', 'Lugo', 'Madrid', 'Málaga', 'Murcia', 'Navarra', 'Ourense', 'Palencia', 'Pontevedra', 'Salamanca', 'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Santa Cruz de Tenerife', 'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Vizcaya', 'Zamora', 'Zaragoza'];

            function fakeJustSold() {
                const rndInt = Math.floor(Math.random() * 30) + 1
                const randomCity = cityArray[Math.floor(Math.random() * cityArray.length)];

                const object1 = {
                    'city': randomCity,
                    'product': 'Cafetera superautomática Sensazione',
                    'image': 'https://www.ufesa.es/cdn/shop/files/Cafetera-superautomatica-Sensazione-102_2.jpg?v=1707915829'
                }

                
                document.querySelector('.jsf-card .jsf-image').style.cssText = `background-image: url("${object1.image}");`;
                document.querySelector('.jsf-card .jsf-description .city').innerHTML= object1.city;
                document.querySelector('.jsf-card .jsf-description .time-ago span').innerHTML= rndInt;

            

                setTimeout(() => {
                    document.querySelector('.jsf-card').classList.add('active');
                }, 4000);
                setTimeout(() => {
                    if(document.querySelector('.jsf-card').classList.contains('active')){
                        document.querySelector('.jsf-card').classList.remove('active');
                        document.querySelector('.jsf-card').classList.add('removal');
                    }
                }, 10000);
                setTimeout(() => {
                    document.querySelector('.jsf-card').classList.remove('removal');
                }, 11000);

                document.querySelector('.jsf-card .close').addEventListener('click', () => {
                    document.querySelector('.jsf-card').classList.remove('active');
                    document.querySelector('.jsf-card').classList.add('removal');
                    setTimeout(() => {
                        document.querySelector('.jsf-card').classList.remove('removal');
                        document.querySelector('body').classList.add('block-jsf');
                    }, 1000);
                });
            }//fakeJustSold function


            fakeJustSold();

            setInterval(() => {
                if(!document.querySelector('body').classList.contains('block-jsf')){
                    fakeJustSold();
                } else {return;}
            }, 40000);

    
  }); //DOMContentLoaded
} */
//template-page-flash-sales


if (document.querySelector('.template-page-flash-october24')) {
  document.addEventListener('DOMContentLoaded', function() {
            const cityArray = ['A Coruña', 'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Baleares', 'Barcelona', 'Burgos', 'Cáceres', 'Cádiz', 'Cantabria', 'Castellón', 'Ciudad Real', 'Córdoba', 'Cuenca', 'Girona', 'Granada', 'Guadalajara', 'Gipuzkoa', 'Huelva', 'Huesca', 'Jaén', 'La Rioja', 'Las Palmas', 'León', 'Lérida', 'Lugo', 'Madrid', 'Málaga', 'Murcia', 'Navarra', 'Ourense', 'Palencia', 'Pontevedra', 'Salamanca', 'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Santa Cruz de Tenerife', 'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Vizcaya', 'Zamora', 'Zaragoza'];
            let triggerCount = 0;

            function fakeJustSold() {

                const rndInt = Math.floor(Math.random() * 30) + 1
                const randomCity = cityArray[Math.floor(Math.random() * cityArray.length)];

                const object1 = {
                    'city': randomCity,
                    'product': 'Cafetera Espresso Monza',
                    'image': 'https://cdn.shopify.com/s/files/1/0727/9286/7151/files/fake-monza.jpg?v=1727772715'
                }
                const object2 = {
                    'city': randomCity,
                    'product': 'Centro de planchado Digital Care',
                    'image': 'https://cdn.shopify.com/s/files/1/0727/9286/7151/files/fake-digital-care.jpg?v=1727772714'
                }
                const object3 = {
                    'city': randomCity,
                    'product': 'Robot multifunción TotalChef RK7',
                    'image': 'https://cdn.shopify.com/s/files/1/0727/9286/7151/files/fake-rk7.jpg?v=1727772715'
                }

                
              if(triggerCount == 0) {
                document.querySelector('.jsf-card .jsf-image').style.cssText = `background-image: url("${object1.image}");`;
                document.querySelector('.jsf-card .jsf-description .city').innerHTML= object1.city;
                document.querySelector('.jsf-card .jsf-description h5').innerHTML= object1.product;
                document.querySelector('.jsf-card .jsf-description .time-ago span').innerHTML= rndInt;
                triggerCount++
              } else if(triggerCount == 1) {
                document.querySelector('.jsf-card .jsf-image').style.cssText = `background-image: url("${object2.image}");`;
                document.querySelector('.jsf-card .jsf-description .city').innerHTML= object2.city;
                document.querySelector('.jsf-card .jsf-description h5').innerHTML= object2.product;
                document.querySelector('.jsf-card .jsf-description .time-ago span').innerHTML= rndInt;
                triggerCount++
              } else {
                document.querySelector('.jsf-card .jsf-image').style.cssText = `background-image: url("${object3.image}");`;
                document.querySelector('.jsf-card .jsf-description .city').innerHTML= object3.city;
                document.querySelector('.jsf-card .jsf-description h5').innerHTML= object3.product;
                document.querySelector('.jsf-card .jsf-description .time-ago span').innerHTML= rndInt;
                triggerCount = 0;
              }
              
                setTimeout(() => {
                    document.querySelector('.jsf-card').classList.add('active');
                }, 4000);
                setTimeout(() => {
                    if(document.querySelector('.jsf-card').classList.contains('active')){
                        document.querySelector('.jsf-card').classList.remove('active');
                        document.querySelector('.jsf-card').classList.add('removal');
                    }
                }, 10000);
                setTimeout(() => {
                    document.querySelector('.jsf-card').classList.remove('removal');
                }, 11000);

                document.querySelector('.jsf-card .close').addEventListener('click', () => {
                    document.querySelector('.jsf-card').classList.remove('active');
                    document.querySelector('.jsf-card').classList.add('removal');
                    setTimeout(() => {
                        document.querySelector('.jsf-card').classList.remove('removal');
                        document.querySelector('body').classList.add('block-jsf');
                    }, 1000);
                });
            }//fakeJustSold function


            fakeJustSold();

            setInterval(() => {
                if(!document.querySelector('body').classList.contains('block-jsf')){
                    fakeJustSold();
                } else {return;}
            }, 40000);

    
  }); //DOMContentLoaded
}//template-page-flash-october24



/* if (window.location.pathname.includes('/cafetera-superautomatica-sensazione-para-cafe-en-grano-y-molido')) {
  document.addEventListener('DOMContentLoaded', function() {

    inventoryLevelFunc();

    const variation = document.querySelectorAll('.variations .product-form__input--color input[type=radio]+label');
    variation.forEach(function(elem) {
        elem.addEventListener('click', function() {
          let elem = document.querySelector('.product-inventory-notice--wrapper');
          let observer = new MutationObserver(mutationRecords => {
              console.log(mutationRecords); // console.log(los cambios)

              inventoryLevelFunc();
              observer.disconnect();
            });
            
            // observa todo exceptuando atributos
            observer.observe(elem, {
              childList: true, // observa hijos directos
              subtree: true, // y descendientes inferiores también
              characterDataOldValue: true // pasa el dato viejo al callback
            });
        });
    });
    
  }); //DOMContentLoaded
} */

/* function inventoryLevelFunc() {
  const quantity = stockQuantity();
    
  document.querySelector('.product-inventory-notice--text').innerHTML =`<div class="product-inventory-notice--pulse"></div>Sólo quedan <strong>${quantity}</strong> en stock`;

  document.querySelector('.product-section .product-inventory-notice--bar').setAttribute('style', '');
  const inventoryLevel = document.querySelector('.product-section .product-inventory-notice--bar span');
  inventoryLevel.style.width = quantity + '%';

  document.querySelector('.product-inventory-notice--text strong').style.cssText = 'margin:0 5px;font-size:17px;font-weight: 700;';
}

function stockQuantity() {
  const fechaIni = new Date();
  const fechaFin = new Date("2024-03-01T09:00:00.000Z");
  
  //console.log(fechaIni);
  //console.log(fechaFin);
  
  const diasDif = fechaFin.getTime() - fechaIni.getTime();
  //console.log(diasDif)
  
  const stockQuantity = Math.round(diasDif/(100 * 60 * 60 * 24) * 0.8 +3);
  //console.log(stockQuantity);

  return stockQuantity;
} */


if (window.location.href === 'https://www.ufesa.es/' || window.location.pathname.includes('/navidad')) {
  document.addEventListener('DOMContentLoaded', function() {

  const subcollections = document.querySelectorAll('div.shopify-section.section-multicolumn .multicolumn .multicolumn__column');
  
  subcollections.forEach((item) => {
    item.style.cssText = 'cursor: pointer;';
    const target = item.querySelector('a').getAttribute("href");
    item.addEventListener('click', (event) => {
      event.preventDefault();
      window.location = (target); 
    });
  });
    
  }); //DOMContentLoaded
}



if (window.location.pathname.includes('/phoenixrecipes')) {
  document.addEventListener('DOMContentLoaded', function() {
        
    const replacements = {
      'es': 'https://cdn.shopify.com/s/files/1/0727/9286/7151/files/Recetario-AirFryer_Vapor_ES_b5ba25ca-e2a5-43aa-9cc9-45eaa3f7be9a.pdf',
      'en': 'https://cdn.shopify.com/s/files/1/0727/9286/7151/files/Recetario-AirFryer_Vapor_EN_5fc1c08d-a960-4205-9187-4161f67703bd.pdf',
      'fr': 'https://cdn.shopify.com/s/files/1/0727/9286/7151/files/Recetario-AirFryer_Vapor_FR_3cc0c13a-84d9-44d8-b7ce-473a87474ec5.pdf',
      'pt': 'https://cdn.shopify.com/s/files/1/0727/9286/7151/files/Recetario-AirFryer_Vapor_PT_0c5bb851-249b-4a8c-adf1-9cf26590f127.pdf',
      'it': 'https://cdn.shopify.com/s/files/1/0727/9286/7151/files/Recetario-AirFryer_Vapor_IT_4a7e206a-94e7-4b46-b579-c7483bf357fb.pdf',
      'de': 'https://cdn.shopify.com/s/files/1/0727/9286/7151/files/Recetario-AirFryer_Vapor_DE_6e51879f-e101-4e1e-97fe-c3bca3f14f9f.pdf'
    };

    const mySelect = document.querySelector('.form-control');
    const myButton = document.querySelector('.button');
  
     mySelect.onchange = function(event) {
      const inputText = event.target.value;
      //console.log(inputText);
      if (replacements[inputText]) {
        myButton.setAttribute('href', replacements[inputText]); 
      }
    };


    myButton.addEventListener('click', function(e) {
      if(myButton.href.includes('phoenixrecipes')) {
        e.preventDefault();
        addElement();
      } else {
        downloadBlob(myButton.href, 'Recipe-book');
        addElement();
      }
    });

    //Forzar descarga de documento
    function downloadBlob(url, filename) {
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
      .catch(() => alert('An error sorry'));
    };

    function addElement() {
      if(document.querySelector('.msg')) {
        document.querySelector('.msg').remove();
      }
      const msg = document.createElement('div');

      msg.style.cssText = 'text-align: center;width: 100%;display: inline-block;top: 100%;position: absolute;padding: 0.75rem 1.25rem;font-size:14px;color: #155724;background-color: #d4edda;border-color: #c3e6cb;';


      switch (mySelect.value) {
        case 'es':
          msg.innerHTML = '¡Gracias! Esperamos que distrutes de tu recetario.';
          break;
        case 'en':
          msg.innerHTML = 'Thank you! We hope you enjoy your recipe book.';
          break;
        case 'fr':
          msg.innerHTML = 'Merci! Nous espérons que vous apprécierez votre livre de recettes.';
          break;
        case 'pt':
          msg.innerHTML = 'Obrigado! Esperamos que você goste do seu livro de receitas.';
          break;
        case 'it':
          msg.innerHTML = 'Grazie! Ci auguriamo che il tuo ricettario ti piaccia.';
          break;
        case 'de':
          msg.innerHTML = 'Danke schön! Wir hoffen, dass Ihnen Ihr Rezeptbuch gefällt.';
          break;
        default:
          msg.style.cssText = 'text-align: center;width: 100%;display: inline-block;top: 100%;position: absolute;padding: 0.75rem 1.25rem;font-size:14px;color: #004085;background-color: #cce5ff;border-color: #b8daff;';
          msg.innerHTML = 'Please, select your language first.';
      }
      
      document.querySelector('form').appendChild(msg);
      msg.classList.add('msg');
    }
         
  }); //DOMContentLoaded
}